export const makeFilterStatuses = (statuses, t) =>
  Object.values(statuses).reduce(
    (statuses, status) => ({
      ...statuses,
      [status]: t(`status.${status}`),
    }),
    {}
  );
